import { NetworkError } from '@/errors';
import { addMetric, createException, createWarning } from '@/utils/monitoring.utils';

type HandleErrorOptions = {
  metricName?: string;
  channel?: string;
  networkMessage?: string;
  unexpectedMessage?: string;
  metricContext?: Record<string, string>;
};

export const handleError = (error: unknown, options: HandleErrorOptions = {}): string => {
  const {
    metricName = 'cancellations-table',
    channel = 'merchant',
    networkMessage = '',
    unexpectedMessage = '',
    metricContext = {},
  } = options;

  if (error instanceof NetworkError) {
    createWarning(error);
    addMetric(metricName, { status: 'network_error', channel, ...metricContext });
    return networkMessage;
  }

  createException(error);
  addMetric(metricName, { status: 'error', channel, ...metricContext });
  return unexpectedMessage;
};
